if (!customElements.get("marsh-size-guide")) {
  customElements.define(
    "marsh-size-guide",
    class MarshSizeGuide extends HTMLElement {
      constructor() {
        super();
        this.selectors = {
          source: "[data-marsh-size-guide-source]",
          openButton: "[data-marsh-open-sizeguide]",
        };
        this.unitChangeHandler = null;
      }

      connectedCallback() {
        this.source = this.querySelector(this.selectors.source);
        if (!this.source || !this.source.innerHTML) return;

        this.contentHtml = this.source.innerHTML;
        this.colorScheme = this.source.dataset.colorScheme || "";
        this.modal = new MinimogTheme.Modal();

        this.removeDelegate = addEventDelegate({
          selector: this.selectors.openButton,
          handler: (e) => {
            e.preventDefault();
            this.open();
          },
        });
      }

      disconnectedCallback() {
        if (typeof this.removeDelegate === "function") this.removeDelegate();
        this.unbindUnitToggle();
      }

      open() {
        if (!this.contentHtml || !this.modal) return;

        const html = document.createElement("div");
        html.className = "marsh-size-guide__modal-content";
        html.innerHTML = this.contentHtml;

        this.modal.appendChild(html);
        this.modal.setWidth("720px");
        this.modal.setSizes(`marsh-size-guide-modal m-gradient ${this.colorScheme}`.trim());
        this.bindUnitToggle(html);
        this.modal.open();
      }

      bindUnitToggle(root) {
        this.unbindUnitToggle();

        const select = root.querySelector("[data-marsh-size-guide-unit]");
        if (!select) return;

        this.unitChangeHandler = () => {
          const unit = select.value;
          root.querySelectorAll("[data-marsh-size-guide-media]").forEach((media) => {
            const match = media.getAttribute("data-marsh-size-guide-media") === unit;
            media.hidden = !match;
            media.classList.toggle("m:hidden", !match);
          });
        };

        select.addEventListener("change", this.unitChangeHandler);
        this.unitChangeHandler();
      }

      unbindUnitToggle() {
        if (!this.unitChangeHandler) return;
        // Previous select may already be gone with the modal; no-op safe.
        this.unitChangeHandler = null;
      }
    }
  );
}
